import { GET_QUEUE_POSITIONS, GET_QUEUE_POSITIONS_SUCCESS, GET_QUEUE_POSITIONS_ERROR } from './actionTypes';

export const getQueuePositions = (user, history) => {
  return {
    type: GET_QUEUE_POSITIONS,
    payload: { user, history },
  };
};

export const getQueuePositionsSuccess = (message, queue_positions) => {
  return {
    type: GET_QUEUE_POSITIONS_SUCCESS,
    payload: { message, queue_positions },
  };
};

export const getQueuePositionsError = (message) => {
  return {
    type: GET_QUEUE_POSITIONS_ERROR,
    payload: message,
  };
};
